var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b34823bb-54c5-4248-96df-16f3b0e34aaf",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 966 727.8",
    style: {
      enableBackground: "new 0 0 966 727.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00FF22;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#E6E6E6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "799.3,228.8 208.7,228.8 208.7,422.7 231.1,422.7 231.1,473.4 281.8,422.7 799.3,422.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.4,
    y: 294.5,
    className: "st1",
    width: 268.5,
    height: 8.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.4,
    y: 322.7,
    className: "st1",
    width: 468.1,
    height: 8.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.4,
    y: 350.9,
    className: "st1",
    width: 467.6,
    height: 8.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 230.9,
    cy: 492.8,
    rx: 64.2,
    ry: 6.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage4);
export default __webpack_public_path__ + "static/media/Image_4.a0f5b6381f893638b22344f554cd2ab2.svg";
export { ForwardRef as ReactComponent };